import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../../reducers/types";
import { actions } from "../../../../actions";
import {
  getLocation,
  getLocationCategories,
  getLocationCategoriesLoading,
  getHasLocationAutocompleteError,
  getStayType,
  getVacationRentalsLocation,
  getVacationRentalsLocationCategories,
} from "../../../../reducer";
import { LocationSearch } from "./component";

const mapDispatchToProps = {
  setLocation: actions.setLocation,
  setLocationAutocompleteError: actions.setLocationAutocompleteError,
  setVacationRentalsLocation: actions.setVacationRentalsLocation,
  fetchPCLocationAutocomplete: actions.fetchPCLocationAutocomplete,
  fetchVRLocationAutocomplete: actions.fetchVRLocationAutocomplete,
};
const mapStateToProps = (state: IStoreState) => ({
  location: getLocation(state),
  rawLocationCategories: getLocationCategories(state),
  loading: !!getLocationCategoriesLoading(state),
  hasLocationAutocompleteError: getHasLocationAutocompleteError(state),
  stayType: getStayType(state),
  vacationRentalsLocation: getVacationRentalsLocation(state),
  rawVacationRentalsLocationCategories: getVacationRentalsLocationCategories(state),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type LocationSearchConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedLocationSearch = connector(LocationSearch);
